export const base_path = '/customer'